<template>
  <v-container class="pl-0 pr-0" fluid>
    <v-layout wrap>
      <v-flex xs12 sm12 class="mb-4">
        <h3 class="mb-4">{{ $t('simulator.wizard.title') }}</h3>
        <v-stepper v-model="step" alt-labels>
          <v-stepper-header>
            <v-stepper-step :complete="step > 1" step="1">
              {{ $t('simulator.wizard.brand') }}
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 2" step="2">
              {{ $t('simulator.wizard.machine') }}
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 3" step="3">
              {{ $t('simulator.wizard.device') }}
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="4">{{ $t('simulator.wizard.version') }}</v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-row class="mb-12"
                ><v-col
                  ><v-btn text @click="$router.push('/applications')">
                    {{ $t('common.cancel') }}
                  </v-btn></v-col
                ></v-row
              >
              <v-row class="pb-15">
                <v-col
                  v-for="group in groups"
                  :key="group.id"
                  :class="[
                    'd-flex',
                    'child-flex',
                    'flex-column',
                    'pointer',
                    'pa-10',
                    'rounded-lg',
                    { 'grey lighten-2': hoverGroup === group.groupName },
                  ]"
                  cols="6"
                  @click="selectGroup(group.group)"
                  @mouseover="hoverGroup = group.groupName"
                  @mouseleave="hoverGroup = null"
                >
                  <v-img
                    :src="logosSrc[group.groupName]"
                    max-height="100px"
                    max-width="350px"
                    :style="{ margin: 'auto' }"
                    contain
                  >
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                  <div align="center" class="pt-3 text-button">
                    {{ group.groupName }}
                  </div>
                </v-col>
              </v-row>
              <v-row class="pb-5" align="center" justify="center">
                <v-btn class="all" text @click="selectMachine('all')">
                  {{ $t('simulator.wizard.showAll') }}
                </v-btn></v-row
              >
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-row
                ><v-col
                  ><v-btn
                    text
                    @click="
                      () => {
                        step = 1;
                        selectedGroup = null;
                      }
                    "
                    ><v-icon left> mdi-arrow-left </v-icon>{{ $t('common.back') }}
                  </v-btn></v-col
                >
                <v-col align="right"></v-col
              ></v-row>
              <v-row>
                <v-col
                  v-for="machine in selectedBrand"
                  :key="machine.machine"
                  :class="[
                    'd-flex child-flex pointer',
                    'rounded-lg',
                    { 'grey lighten-2': hoverMachine === machine.machine },
                  ]"
                  cols="6"
                  @mouseover="hoverMachine = machine.machine"
                  @mouseleave="hoverMachine = null"
                  @click="selectMachine(machine.machine)"
                >
                  <div class="pt-10 pl-10 pr-10 pb-5 rounded-lg">
                    <v-img :src="machinesSrc[machine.machine]" height="150px" contain>
                      <!-- , { hover: hoverGroup === group.groupName } -->
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <div align="center" class="pt-3 text-button">
                      {{ machine.machine }}
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-row
                ><v-col
                  ><v-btn
                    text
                    @click="
                      () => {
                        selectedMachine === 'all' ? (step = 1) : (step = 2);
                        selectedMachine = null;
                      }
                    "
                    ><v-icon left> mdi-arrow-left </v-icon>{{ $t('common.back') }}
                  </v-btn></v-col
                >
              </v-row>
              <v-row>
                <v-col
                  v-for="device in selectedMachineArray"
                  :key="device.device"
                  class="d-flex child-flex pointer"
                  cols="3"
                  @mouseover="hoverDevice = device.device"
                  @mouseleave="hoverDevice = null"
                  @click="selectDevice(device.device)"
                >
                  <div
                    :class="[
                      'pt-10',
                      'pl-10',
                      'pr-10',
                      'pb-5',
                      'rounded-lg',
                      { 'grey lighten-2': hoverDevice === device.device },
                    ]"
                  >
                    <v-img
                      v-if="presignedTerminals"
                      :src="presignedTerminals[device.device]"
                      height="150px"
                      contain
                    >
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <div align="center" class="pt-3 text-button">
                      {{ device.device }}
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-stepper-content>
            <v-stepper-content step="4">
              <v-row
                ><v-col
                  ><v-btn
                    text
                    @click="
                      () => {
                        step = 3;
                        selectedDevice = null;
                      }
                    "
                  >
                    <v-icon left> mdi-arrow-left </v-icon>{{ $t('common.back') }}
                  </v-btn></v-col
                >
              </v-row>
              <v-row>
                <v-col
                  v-for="app in selectedDeviceArray"
                  :key="app._id"
                  class="d-flex child-flex pointer"
                  cols="3"
                  @mouseover="hoverApp = app._id"
                  @mouseleave="hoverApp = null"
                >
                  <router-link :to="{ name: 'InstanceView', params: { id: app._id } }">
                    <div
                      :class="[
                        'pt-10',
                        'pl-10',
                        'pr-10',
                        'pb-5',
                        'rounded-lg',
                        { 'grey lighten-2': hoverApp === app._id },
                      ]"
                    >
                      <v-img
                        v-if="presignedApps"
                        :src="presignedApps[app._id]"
                        height="150px"
                        contain
                      >
                        <template v-slot:placeholder>
                          <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular
                              indeterminate
                              color="grey lighten-5"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <div align="center" class="pt-3 text-button">
                        {{ app.software }}
                      </div>
                    </div>
                  </router-link>
                </v-col>
              </v-row>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { presignURL } from '@/auth/utils';
import axios from 'axios';
import notifications from '@/utils/notifications';
import { translateApiError } from '@/utils/apiError';

export default {
  name: 'launch-wizard',
  data() {
    return {
      step: 1,
      groups: [],
      hoverGroup: null,
      selectedGroup: null,
      hoverMachine: null,
      selectedMachine: null,
      presignedTerminals: null,
      hoverDevice: null,
      selectedDevice: null,
      hoverApp: null,
      presignedApps: null,
      allDevices: [],
    };
  },
  computed: {
    ...mapGetters(['isUserAdmin']),
    logosSrc() {
      return {
        Challenger: '/static/ui-elements/brand_logo_challenger.png',
        dev_challenger: '/static/ui-elements/brand_logo_challenger.png',
        Fendt: '/static/ui-elements/brand_logo_fendt.png',
        dev_fendt: '/static/ui-elements/brand_logo_fendt.png',
        MasseyFerguson: '/static/ui-elements/brand_logo_massey_ferguson.png',
        dev_mf: '/static/ui-elements/brand_logo_massey_ferguson.png',
        Valtra: '/static/ui-elements/brand_logo_valtra.png',
        dev_valtra: '/static/ui-elements/brand_logo_valtra.png',
      };
    },
    machinesSrc() {
      return {
        'Combine Harvester': '/static/ui-elements/combine2.png',
        'Forage Harvester': '/static/ui-elements/forage.png',
        Tractor: '/static/ui-elements/tractor.png',
        Sprayer: '/static/ui-elements/sprayer2.png',
      };
    },
    selectedBrand() {
      if (!this.selectedGroup) return null;

      const matchGroup = this.groups.find((group) => group.group === this.selectedGroup);

      return matchGroup.types;
    },
    selectedMachineArray() {
      if (!this.selectedBrand || !this.selectedMachine) return this.allDevices;

      const matchMachine = this.selectedBrand.find(
        (machine) => machine.machine === this.selectedMachine
      );

      return matchMachine.devices;
    },
    selectedDeviceArray() {
      if (!this.selectedDevice || !this.selectedMachineArray) return [];

      const matchDevice = this.selectedMachineArray.find(
        (device) => device.device === this.selectedDevice
      );

      return matchDevice.applications;
    },
  },
  methods: {
    selectGroup(groupId) {
      this.selectedGroup = groupId;
      this.step = 2;
    },
    async selectMachine(machineType) {
      this.selectedMachine = machineType;
      if (this.selectedMachineArray) {
        await this.getTerminalPresignedUrls();
      }

      this.step = 3;
    },
    async selectDevice(device) {
      this.selectedDevice = device;
      if (this.selectedMachineArray) {
        await this.getAppPresignedUrls();
      }

      this.step = 4;
    },
    /* eslint-disable no-param-reassign */
    async getTerminalPresignedUrls() {
      if (this.selectedMachineArray) {
        const urls = await this.selectedMachineArray.reduce(async (prev, curr) => {
          const prevFulfilled = await prev;
          prevFulfilled[curr.device] = await presignURL({
            id: curr.terminal,
            resource: 'terminals',
          });
          return prevFulfilled;
        }, Promise.resolve({}));
        this.presignedTerminals = urls;
      }
      return {};
    },
    async getAppPresignedUrls() {
      if (this.selectedDeviceArray) {
        const urls = await this.selectedDeviceArray.reduce(async (prev, curr) => {
          const prevFulfilled = await prev;
          prevFulfilled[curr._id] = await presignURL({
            id: curr._id,
            resource: 'applications',
          });
          return prevFulfilled;
        }, Promise.resolve({}));
        this.presignedApps = urls;
      }
      return {};
    },
    /* eslint-enable no-param-reassign */
    async fetchGroups() {
      try {
        const { data } = await axios.get('launcher/config');
        this.groups = data;
      } catch (err) {
        notifications.$emit('error', translateApiError(err, 'errors.loadFailed.applications'));
      }
    },
    async fetchDevices() {
      try {
        const { data } = await axios.get('launcher/devices');
        this.allDevices = data;
      } catch (err) {
        notifications.$emit('error', translateApiError(err, 'errors.loadFailed.applications'));
      }
    },
  },

  async mounted() {
    await this.fetchGroups();
    await this.fetchDevices();
  },
};
</script>

<style scoped>
a {
  color: inherit;
  text-decoration: none;
}

.application-card img {
  width: 100%;
}

.ml-auto {
  margin-left: auto;
}
.pointer {
  cursor: pointer;
}

.all.v-btn {
  font-size: x-large;
  margin: auto;
  width: 350px;
  height: 100px;
}
.row {
  margin: 0;
}
</style>
